import { MdDashboard, MdLocalShipping } from 'react-icons/md';
import { IoIosDocument, IoIosCash } from 'react-icons/io';
import { FaFileInvoiceDollar, FaMoneyBillWave, FaUserTie, FaChartLine, FaBuilding } from 'react-icons/fa';
import Images from 'assets/img';
import {Security as SecurityIcon} from '@material-ui/icons';
import { Icon } from 'styles/components';

// Configuração dos módulos disponíveis
export const MODULES = {
  TRANSPORTE: {
    id: 'transporte',
    name: 'Transporte',
    icon: MdLocalShipping,
    color: '#122D58',
    menus: [
      {
        path: '/dashboard',
        label: 'Dashboard',
        icon: MdDashboard,
      },
      {
        path: '/transport/pedidos-frete',
        label: 'Pedido de Frete',
        icon: FaFileInvoiceDollar,
      },
      {
        path: '/trip',
        label: 'Viagem',
        icon: IoIosDocument,
      },
      {
        path: '/trucker',
        label: 'Caminhoneiros',
        icon: 'custom',
        customIcon: () => <Icon pointer width="20px" src={Images.IconGrayUsers} />,
      },
      {
        path: '/providers',
        label: 'Empresas',
        icon: 'custom',
        customIcon: () => <Icon pointer width="20px" src={Images.IconProviders} />,
      },
      {
        path: '/insurances',
        label: 'Seguros',
        icon: SecurityIcon,
      },
      {
        path: '/cargas',
        label: 'Carga',
        icon: 'custom',
        customIcon: () => <Icon pointer width="20px" src={Images.IconGrayTruck} />,
      },
      {
        path: '/collaborators',
        label: 'Colaboradores',
        icon: 'custom',
        customIcon: () => <Icon pointer width="20px" src={Images.IconUserGear} />,
      },
      {
        path: '/profiles',
        label: 'Perfis',
        icon: SecurityIcon,
      },
    ],
  },
  FINANCEIRO: {
    id: 'financeiro',
    name: 'Financeiro',
    icon: IoIosCash,
    color: '#44DD30',
    menus: [
      {
        path: '/financeiro/dashboard',
        label: 'Dashboard',
        icon: MdDashboard,
      },
      {
        path: '/financeiro/contas-pagar',
        label: 'Contas a Pagar',
        icon: FaFileInvoiceDollar,
      },
      {
        path: '/financeiro/contas-receber',
        label: 'Contas a Receber',
        icon: FaMoneyBillWave,
      },
      {
        path: '/financeiro/clientes',
        label: 'Clientes',
        icon: FaUserTie,
      },
      {
        path: '/financeiro/naturezas',
        label: 'Naturezas',
        icon: FaChartLine,
      },
      {
        path: '/financeiro/fornecedores',
        label: 'Fornecedores',
        icon: FaBuilding,
      },
     
    ],
  },
  EMBARCADORES: {
    id: 'embarcadores',
    name: 'Embarcadores',
    icon: FaUserTie,
    color: '#FFB703',
    menus: [
      {
        path: '/embarcadores/dashboard',
        label: 'Dashboard',
        icon: MdDashboard,
      },
      {
        path: '/embarcadores/list',
        label: 'Embarcadores',
        icon: FaUserTie,
      },
      {
        path: '/embarcadores/fretes',
        label: 'Fretes',
        icon: IoIosDocument,
      },
      {
        path: '/embarcadores/acompanhamento-carga',
        label: 'Carga',
        icon: MdLocalShipping,
      },
    ],
  },
};

// Função para obter módulo por ID
export const getModuleById = (moduleId) => {
  return Object.values(MODULES).find((module) => module.id === moduleId);
};

// Função para obter módulo atual do localStorage
export const getCurrentModuleFromStorage = () => {
  const stored = localStorage.getItem('currentModule');
  if (stored) {
    return getModuleById(stored);
  }
  return MODULES.TRANSPORTE; // Módulo padrão
};

// Função para salvar módulo atual no localStorage
export const saveCurrentModuleToStorage = (moduleId) => {
  localStorage.setItem('currentModule', moduleId);
};

